// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../element-variables.scss'
import '@/assets/fonts/fonts.css'


import VueMeta from 'vue-meta';
Vue.use(VueMeta);



import axios from 'axios'
Vue.prototype.axios = axios
// Vue.use(axios)

// Vue.prototype.$hls = Hls


// 设置语言名
import locale from 'element-ui/lib/locale'
import en from 'element-ui/lib/locale/lang/en'

// import ElementUI from 'element-ui'


Vue.config.productionTip = false // 引入英文语言包
// 设置ElementUI的语言
locale.use(en)
Vue.config.productionTip = false
// Vue.use(ElementUI)

import httpinfo from './assets/js/httpinfo.js'
Vue.prototype.httpinfo = httpinfo
Vue.use(httpinfo)

Vue.prototype.baseURL = 'https://api.komovie.xyz/user_api1/'
Vue.prototype.baseOther = 'https://api.komovie.xyz/user/'
// Vue.prototype.baseURL = 'http://127.0.0.1/user/'

new Vue({
  axios,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
